import {Box} from "@mui/material";

export function TabPanel(props) {
    const { children, value, index, childSx, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={childSx?childSx:{p:3}}>
                    {children}
                </Box>
            )}
        </div>
    );
}